import React from "react";

const StratusNotFound = () => {
  return (
    <div
      id="stratus--not-found"
      className={"flex flex-col w-full gap-32 md:gap-64 max-w-5xl px-4"}
    >
      <div className="flex flex-col w-full items-center gap-4">
        <i className="fas fa-exclamation-triangle text-6xl text-color-dark-text-tertiary"></i>
        <div className="text-center font-medium text-color-dark-text-tertiary">
          We're sorry, this page is currently unavailable.
        </div>
      </div>
    </div>
  );
};

export default StratusNotFound;
